import { render } from "./RecruitmentBase.component.vue?vue&type=template&id=0c409852"
import script from "./RecruitmentBase.component.vue?vue&type=script&lang=js"
export * from "./RecruitmentBase.component.vue?vue&type=script&lang=js"

import "./RecruitmentBase.component.vue?vue&type=style&index=0&id=0c409852&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
